"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCurrentCdnAdaptor = exports.useCdnAdaptor = exports.CdnAdaptorConfig = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _core = require("../../core");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var cdnAdaptorWeekMap = new WeakMap();

var getCdnAdaptor = function getCdnAdaptor(config) {
  if (!cdnAdaptorWeekMap.has(config)) cdnAdaptorWeekMap.set(config, new _core.CdnAdaptor(config)); // eslint-disable-next-line @typescript-eslint/no-non-null-assertion

  return cdnAdaptorWeekMap.get(config);
};

var CdnAdaptorContext = /*#__PURE__*/_react["default"].createContext({
  cdnConfigs: {}
});

var useCdnAdaptor = function useCdnAdaptor() {
  try {
    return _react["default"].useContext(CdnAdaptorContext);
  } catch (e) {
    return null;
  }
};

exports.useCdnAdaptor = useCdnAdaptor;

var useCurrentCdnAdaptor = function useCurrentCdnAdaptor(config) {
  var superCdnAdaptor = useCdnAdaptor();

  if (!config && !superCdnAdaptor) {
    throw new Error('when config is empty, useCurrentCdnAdaptor must be use in CdnAdaptorConfig!');
  }

  if (config) {
    if (!superCdnAdaptor) return _objectSpread(_objectSpread({}, config), {}, {
      cdnAdaptor: getCdnAdaptor(config)
    });

    var newConfig = _objectSpread(_objectSpread({}, superCdnAdaptor === null || superCdnAdaptor === void 0 ? void 0 : superCdnAdaptor.cdnConfigs), config);

    return _objectSpread(_objectSpread({}, newConfig), {}, {
      cdnAdaptor: new _core.CdnAdaptor(newConfig)
    });
  } else {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return superCdnAdaptor;
  }
};

exports.useCurrentCdnAdaptor = useCurrentCdnAdaptor;

var CdnAdaptorConfig = function CdnAdaptorConfig(props) {
  var value = useCurrentCdnAdaptor(props.value);
  return /*#__PURE__*/_react["default"].createElement(CdnAdaptorContext.Provider, {
    value: value
  }, props.children);
};

exports.CdnAdaptorConfig = CdnAdaptorConfig;